import { render, staticRenderFns } from "./ChoferTable.vue?vue&type=template&id=3980933b"
import script from "./ChoferTable.vue?vue&type=script&lang=js"
export * from "./ChoferTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports